import * as _ from 'lodash';
import { DropdownOption } from '../formItem/ElementConfig';
var Ritual = /** @class */ (function () {
    function Ritual(obj, id) {
        if (id) {
            this.id = id;
        }
        this.position = obj.position;
        if (obj.youtube_url) {
            this.youtube_url = obj.youtube_url;
        }
        if (obj.image_url) {
            this.image_url = obj.image_url;
        }
        if (obj.products) {
            this.product_ids = this.getProductsIds(obj.products);
            this.products_formatted = this.getProductsFormatted(obj.products);
        }
    }
    Ritual.prototype.getProductsIds = function (rawProducts) {
        var ids = [];
        for (var _i = 0, rawProducts_1 = rawProducts; _i < rawProducts_1.length; _i++) {
            var prod = rawProducts_1[_i];
            ids.push(Number(prod.value));
        }
        return ids;
    };
    Ritual.prototype.getProductsFormatted = function (rawProducts) {
        var ids = [];
        for (var _i = 0, rawProducts_2 = rawProducts; _i < rawProducts_2.length; _i++) {
            var prod = rawProducts_2[_i];
            ids.push(new DropdownOption({
                label: _.get(prod, 'attributes.name'),
                value: _.get(prod, 'id'),
            }));
        }
        return ids;
    };
    Object.defineProperty(Ritual.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ritual.prototype, "YoutubeUrl", {
        get: function () {
            return this.youtube_url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ritual.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ritual.prototype, "Products", {
        get: function () {
            return this.product_ids;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ritual.prototype, "ProductsFormatted", {
        get: function () {
            return this.products_formatted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ritual.prototype, "ImageUrl", {
        get: function () {
            return this.image_url;
        },
        enumerable: false,
        configurable: true
    });
    return Ritual;
}());
export { Ritual };
export function createRitual(obj, id) {
    return new Ritual(obj, id);
}
export function createRituals(rawRituals) {
    var rituals = [];
    var rawRitualsData = rawRituals.data;
    for (var _i = 0, rawRitualsData_1 = rawRitualsData; _i < rawRitualsData_1.length; _i++) {
        var rawRitual = rawRitualsData_1[_i];
        var ritual = createRitual(rawRitual.attributes, rawRitual.id);
        rituals.push(ritual);
    }
    return rituals;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/ritual/ritual.ts
// module id = 129
// module chunks = 0